import Swal from 'sweetalert2'
import {useNavigate} from 'react-router-dom'
import React, {useState} from 'react'
import {IProduct, productInitValues as initialValues} from '../../models/ProductModel'
import * as Yup from 'yup'
import {useFormik} from 'formik'
import axios from 'axios'
import {useIntl} from 'react-intl'
import HeaderCard from '../../../../../../components/Forms/HeaderCard'
import {Input} from '../../../../../../components/Forms/Input'

import AsyncSelect from 'react-select/async'
import {colourStyles} from '../../../../../../components/Forms/Select/data'

const API_URL = process.env.REACT_APP_API_URL || 'api'

export interface UseOption {
  readonly value: string
  readonly label: string
  readonly color: string
  readonly isFixed?: boolean
  readonly isDisabled?: boolean
}

const ProductSchema = Yup.object().shape({
  // id: Yup.string().required('Campo obrigatório'),
  //name: Yup.string().required('Campo obrigatório'),
  // unit_measure: Yup.string().required('Campo obrigatório'),
  // telephone: Yup.string().required('Campo obrigatório'),
  //descripton: Yup.string().required('Campo obrigatório'),
  // email: Yup.string().required('Campo obrigatório'),
})

const FormProductsAdd: React.FC = () => {
  const intl = useIntl()
  const navigate = useNavigate()

  const [loading, setLoading] = useState(false)
  const formik = useFormik<IProduct>({
    initialValues,
    validationSchema: ProductSchema,
    onSubmit: async (values) => {
      setLoading(true)

      try {
        await axios.post(API_URL + '/v1/products', values)
        setLoading(false)
        Swal.fire({
          icon: 'success',
          title: intl.formatMessage({id: 'PRODUCT.SWAL_ADD'}),
          showConfirmButton: false,
          timer: 2000,
        })
        navigate('/products')
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: intl.formatMessage({id: 'PRODUCT.SWAL_ADD_ERROR'}),
          showConfirmButton: false,
          timer: 1500,
        })

        setLoading(false)
      }
    },
  })
  function resetInputs() {
    formik.resetForm()
  }

  const loadOptions = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getUser()
      var units: any = []
      async function getUser() {
        const {data} = await axios.get(API_URL + '/v1/measurement_units/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const unit: any = {
            value: Response[i].id,
            label: Response[i].abbreviation,
          }

          units.push(unit)
        }
        console.log(Response)
      }
      callback(units)
    }, 1000)
  }

  const handleInputChange = (event: any) => {
    var inputValue = ''
    inputValue = event.value
    formik.setFieldValue('measurement_unit_id', inputValue)
    return {inputValue}
  }

  return (
    <div className='card card-custom mt-n8'>
      {/* Component Header de Cadastros. */}
      <HeaderCard
        buttonBack={intl.formatMessage({id: 'COMMON.BACK_BUTTON'})}
        title={intl.formatMessage({id: 'PRODUCTS.ADD_BUTTON'})}
        routeBack='/products'
      />

      <div id='kt_account_profile_details' className='collapse show'>
        <form onSubmit={formik.handleSubmit} noValidate className='form'>
          <div className='card-body border-top p-9'>
            {/* INICIO NOME */}

            <Input
              title={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              placeholder={intl.formatMessage({id: 'COMMON.INPUT_NAME'})}
              {...formik.getFieldProps('name')}
              required
            />

            {/* FIM NOME */}

            {/* INICIO DESCRIÇÃO ----------------------*/}
            <Input
              title={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              placeholder={intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
              {...formik.getFieldProps('description')}
            />

            {/* FIM DESCRIÇÃO ------------------------------*/}

            {/* INICIO METRICA ----------------------*/}
            <div className='row mb-3'>
              <label className='col-lg-2 col-form-label fw-bold fs-6'>
                <span className='required'>
                  {intl.formatMessage({id: 'PRODUCTS.UNIT_MEASURE'})}
                </span>
              </label>

              <div className='col-lg-10 fv-row'>
                <AsyncSelect
                  className='form-control form-control-lg form-control-solid p-1 pl-1'
                  styles={colourStyles}
                  cacheOptions
                  loadOptions={loadOptions}
                  defaultOptions
                  filterOption={(option, inputValue) =>
                    option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                  }
                  onChange={handleInputChange}
                  placeholder={intl.formatMessage({id: 'SELECT.INPUT_RESPONSIBLE_ISSUE_ORGAN'})}
                />
              </div>
            </div>
            {/* FIM METRICA ------------------------------*/}

            <div className='d-flex justify-content-end py-6'>
              <button type='submit' className='btn btn-primary' disabled={loading}>
                {!loading && intl.formatMessage({id: 'COMMON.SAVE_BUTTON'})}
                {loading && (
                  <span className='indicator-progress' style={{display: 'block'}}>
                    {intl.formatMessage({id: 'COMMON.SAVING_BUTTON'})}{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
                )}
              </button>
              <button type='reset' onClick={resetInputs} className='btn btn-secondary  mx-2'>
                {intl.formatMessage({id: 'COMMON.CLEAR_BUTTON'})}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  )
}

export {FormProductsAdd}
